module.exports = __webpack_public_path__ + "img/ícone-ocultar-senha.a69dcd1b.svg";